import { useI18n } from 'vue-i18n'

export function useCountry(): string {
    const { locale } = useI18n()
    const envCountry = import.meta.env.VITE_VUE_APP_COUNTRY

    if (envCountry === 'at') {
        return 'at'
    }

    return locale.value
}
